import { render, staticRenderFns } from "./showLogin.vue?vue&type=template&id=3b64a6f4&scoped=true&"
import script from "./showLogin.vue?vue&type=script&lang=js&"
export * from "./showLogin.vue?vue&type=script&lang=js&"
import style0 from "./showLogin.vue?vue&type=style&index=0&id=3b64a6f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64a6f4",
  null
  
)

export default component.exports